import React from "react";
import * as S from "./styles";
import { OutlinedInputProps } from "@mui/material";

interface KogInputTextOutlinedProps {
	errorMessageCustom?: string | null;
	onChangeCustom?: (value: string) => void;
}

export type KogInputTextOutlinedType = KogInputTextOutlinedProps & OutlinedInputProps;

const KogInputTextOutlined = React.forwardRef((props: KogInputTextOutlinedType, ref: React.Ref<OutlinedInputProps>) => {
	return <S.InputTextOutlined type="text" fullWidth {...props} ref={ref} />;
});

export default KogInputTextOutlined;
